@if (showVita) {
  <div class="component-content">
    <app-lecturer-vita
      [admin]="true"
      [lecturer]="user"
      (editLecturer)="toggleDetails()"></app-lecturer-vita>
  </div>
}

<div class="component-content" [class.hide-formular]="showVita">
  <div class="header">
    <div class="title">{{ translateUserType(userType) }} Konto</div>
    <div class="flex-r gap-16">
      @if (editMode) {
        <button
          [disabled]="userType !== UserType.COOPERATION"
          [matTooltip]="
            userType === UserType.COOPERATION
              ? ''
              : 'Diese Funktion ist noch nicht verfügbar'
          "
          class="inwi-text-button-medium-secondary"
          (click)="onDeleteUser()">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-trash-can"></i>
            </div>
            <div class="button-text">Löschen</div>
          </div>
        </button>
      }
      @if (activeTab === 'profile') {
        <button class="inwi-text-button-medium-primary" (click)="onSubmit()">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-floppy-disk"></i>
            </div>
            <div class="button-text">Speichern</div>
          </div>
        </button>
      }
    </div>
  </div>
  <div class="main-content">
    @if (isLoading) {
      <div class="user-header">
        <p-skeleton width="100px" height="100px" borderRadius="50%" />
        <div class="flex-c gap-4">
          <p-skeleton width="200px" height="28px" borderRadius="16px" />
          <p-skeleton width="180px" height="20px" borderRadius="16px" />
        </div>
      </div>
    } @else {
      <div class="header">
        <div class="user-header">
          <div class="avatar" [style]="avatarStyles">
            <div [style.display]="avatarLoaded ? 'block' : 'none'">
              <img
                [src]="avatar"
                alt="avatar"
                class="avatar"
                (error)="avatarLoaded = false"
                (load)="avatarLoaded = true" />
            </div>
            @if (!avatarLoaded) {
              {{ getInitials() }}
            }
            @if (userType !== UserType.COOPERATION) {
              <button class="edit-image-button" (click)="onOpenUploadDialog()">
                <i class="fa-regular fa-pen"></i>
              </button>
            }
            <input
              type="file"
              #fileInput
              accept="image/*"
              (change)="onFileSelected($event)"
              style="display: none" />
          </div>
          <div class="flex-c gap-4">
            <div class="section-title">
              @if (userType === UserType.COOPERATION) {
                {{ userForm.get('cooperationName').value ?? '' }}
              } @else {
                {{
                  (userForm.get('firstname').value ?? '') +
                    ' ' +
                    (userForm.get('lastname').value ?? '')
                }}
              }
            </div>
            <div>
              {{ userForm.get('jobTitle').value ?? '' }}
            </div>
          </div>
        </div>
        @if (editMode && userType === 'lecturer') {
          <button class="inwi-text-button-medium" (click)="toggleDetails()">
            <div class="button-content">
              <div class="button-icon">
                <i class="fa-regular fa-sparkle"></i>
              </div>
              <div class="button-text">Vollständige Vita</div>
            </div>
          </button>
        }
      </div>
    }
    <app-tab-menu
      class="tab-menu"
      [tabs]="tabs"
      [activeTab]="activeTab"
      (tabChange)="onTabChange($event)"></app-tab-menu>
    @if (activeTab === 'profile') {
      <form [formGroup]="userForm" class="form">
        <div class="section-title padding-top-24">
          Allgemeine Informationen:
        </div>
        @if (userType !== UserType.COOPERATION) {
          <div class="formular-row-2-inputs">
            <div class="input-simple flex-1-1-0">
              <label for="jobTitle" class="input-label"> Beruf </label>
              <input
                type="text"
                id="jobTitle"
                name="jobTitle"
                class="input-field"
                placeholder="Beruf"
                formControlName="jobTitle" />
              <app-error-message
                [formField]="userForm.get('jobTitle')"></app-error-message>
            </div>
            <div class="input-simple flex-1-1-0 placeholder"></div>
          </div>
        }
        @if (userType === 'cooperation') {
          <div class="formular-row-2-inputs">
            <div class="input-simple flex-1-1-0">
              <label for="cooperationName" class="input-label">
                Kooperationsname
              </label>
              <input
                type="text"
                id="cooperationName"
                name="cooperationName"
                class="input-field"
                placeholder="Kooperationsname"
                formControlName="cooperationName" />
              <app-error-message
                [formField]="
                  userForm.get('cooperationName')
                "></app-error-message>
            </div>
            <div class="input-simple flex-1-1-0 placeholder"></div>
          </div>
        }
        <div class="formular-row-2-inputs">
          <div class="input-simple flex-1-1-0">
            <label for="firstname" class="input-label">
              Vorname{{ fieldRequired(userForm.get('firstname')) ? '*' : '' }}
            </label>
            <input
              type="text"
              id="firstname"
              name="firstname"
              class="input-field"
              placeholder="Vorname"
              formControlName="firstname" />
            <app-error-message
              [formField]="userForm.get('firstname')"></app-error-message>
          </div>
          <div class="input-simple flex-1-1-0">
            <label for="lastname" class="input-label">
              Nachname{{ fieldRequired(userForm.get('lastname')) ? '*' : '' }}
            </label>
            <input
              type="text"
              id="lastname"
              name="lastname"
              class="input-field"
              placeholder="Nachname"
              formControlName="lastname" />
            <app-error-message
              [formField]="userForm.get('lastname')"></app-error-message>
          </div>
        </div>
        <div class="formular-row-2-inputs">
          <div class="input-simple flex-1-1-0">
            <label for="email" class="input-label">
              E-Mail{{ fieldRequired(userForm.get('email')) ? '*' : '' }}</label
            >
            <input
              type="email"
              id="email"
              name="email"
              class="input-field"
              placeholder="max.mustermann@example.com"
              formControlName="email" />
            <app-error-message
              [formField]="userForm.get('email')"></app-error-message>
          </div>
          <div class="input-simple flex-1-1-0">
            <label for="phone" class="input-label">
              Telefon{{ fieldRequired(userForm.get('phone')) ? '*' : '' }}
            </label>
            <input
              type="text"
              id="phone"
              name="phone"
              class="input-field"
              placeholder="+49 123 456789"
              formControlName="phone" />
            <app-error-message
              [formField]="userForm.get('phone')"></app-error-message>
          </div>
        </div>
        @if (userType === 'lecturer') {
          <div class="input-simple flex-1-1-0">
            <div class="input-label-wrapper">
              <label for="description1" class="input-label">
                Beschreibung 1{{
                  fieldRequired(userForm.get('description1')) ? '*' : ''
                }}
              </label>
              <div class="input-label-hint">
                {{ getTextAreaLength(userForm.controls['description1']) }} /
                {{ 1200 }}
              </div>
            </div>
            <textarea
              id="description1"
              name="description1"
              class="input-textarea"
              rows="1"
              placeholder="Beschreibung"
              formControlName="description1"></textarea>
          </div>
          <div class="input-simple flex-1-1-0">
            <div class="input-label-wrapper">
              <label for="description1" class="input-label">
                Beschreibung 2{{
                  fieldRequired(userForm.get('description2')) ? '*' : ''
                }}
              </label>
              <div class="input-label-hint">
                {{ getTextAreaLength(userForm.controls['description2']) }} /
                {{ 1200 }}
              </div>
            </div>
            <textarea
              id="description2"
              name="description2"
              class="input-textarea"
              rows="1"
              placeholder="Beschreibung"
              formControlName="description2"></textarea>
          </div>
          <div class="input-simple flex-1-1-0">
            <div class="input-label-wrapper">
              <label for="description1" class="input-label">
                Beschreibung 3{{
                  fieldRequired(userForm.get('description3')) ? '*' : ''
                }}
              </label>
              <div class="input-label-hint">
                {{ getTextAreaLength(userForm.controls['description3']) }} /
                {{ 1200 }}
              </div>
            </div>
            <textarea
              id="description3"
              name="description3"
              class="input-textarea"
              rows="1"
              placeholder="Beschreibung"
              formControlName="description3"></textarea>
          </div>
          <div class="input-simple flex-1-1-0">
            <div class="input-label-wrapper">
              <label for="description1" class="input-label">
                Tätigkeitsfeld{{
                  fieldRequired(userForm.get('fieldOfActivity')) ? '*' : ''
                }}
              </label>
              <div class="input-label-hint">
                {{ getTextAreaLength(userForm.controls['fieldOfActivity']) }} /
                {{ 1200 }}
              </div>
            </div>
            <textarea
              id="fieldOfActivity"
              name="fieldOfActivity"
              class="input-textarea"
              rows="1"
              placeholder="Tätigkeitsfeld"
              formControlName="fieldOfActivity"></textarea>
          </div>

          <div class="section-title padding-top-24">
            Wichtige Fortbildungen:
          </div>
          <ng-container formArrayName="trainings">
            @for (
              trainingControl of trainings.controls;
              track trainingControl.value
            ) {
              <div class="flex-r gap-24">
                <div class="input-simple flex-1-1-0">
                  <div class="input-label-wrapper">
                    <label
                      for="trainingControl{{ $index }}"
                      class="input-label">
                      Fortbildung {{ $index + 1
                      }}{{ fieldRequired(trainingControl) ? '*' : '' }}
                    </label>
                    <div class="input-label-hint">
                      {{ getTextAreaLength(trainingControl) }}
                      /
                      {{ 1200 }}
                    </div>
                  </div>
                  <textarea
                    id="trainingControl{{ $index }}"
                    name="trainingControl{{ $index }}"
                    class="input-textarea"
                    rows="1"
                    placeholder="Fortbildung"
                    [formControlName]="$index"></textarea>
                  <app-error-message
                    [formField]="
                      trainings.controls[$index]
                    "></app-error-message>
                </div>
              </div>
            }
            <p-divider type="dashed" class="divider-with-button padding-12-0">
              <button class="circle-medium" (click)="addTraining()">
                <i class="fa-solid fa-plus circle-icon circle-icon"></i>
              </button>
            </p-divider>
          </ng-container>

          <div class="section-title">Beruflicher Werdegang:</div>
          <ng-container formArrayName="careerSteps">
            @for (careerStep of careerSteps.controls; track careerStep.value) {
              <div class="flex-r gap-24">
                <div class="input-simple flex-1-1-0">
                  <div class="input-label-wrapper">
                    <label for="careerStep{{ $index }}" class="input-label">
                      Beruflicher Werdegang {{ $index + 1
                      }}{{ fieldRequired(careerStep) ? '*' : '' }}
                    </label>
                    <div class="input-label-hint">
                      {{ getTextAreaLength(careerStep) }}
                      /
                      {{ 1200 }}
                    </div>
                  </div>
                  <textarea
                    id="careerStep{{ $index }}"
                    name="careerStep{{ $index }}"
                    class="input-textarea"
                    rows="1"
                    placeholder="Fortbildung"
                    [formControlName]="$index"></textarea>
                </div>
              </div>
            }
            <p-divider type="dashed" class="divider-with-button padding-12-0">
              <button class="circle-medium" (click)="addCareerStep()">
                <i class="fa-solid fa-plus circle-icon"></i>
              </button>
            </p-divider>
          </ng-container>

          <div class="section-title">Mehr Infos:</div>
          <ng-container formArrayName="publications">
            @for (publication of publications.controls; track publication) {
              <div class="flex-c gap-20" [formGroupName]="$index">
                <div class="flex-r gap-24">
                  <div class="input-simple flex-1-1-0">
                    <div class="input-label-wrapper">
                      <label
                        for="publicationTitle{{ $index }}"
                        class="input-label">
                        Publikation {{ $index + 1
                        }}{{
                          fieldRequired(publication.get('title')) ? '*' : ''
                        }}
                      </label>
                      <div class="input-label-hint">
                        {{ getTextAreaLength(publication.get('title')) }}
                        /
                        {{ 1200 }}
                      </div>
                    </div>
                    <textarea
                      id="publicationTitle{{ $index }}"
                      name="publicationTitle{{ $index }}"
                      class="input-textarea"
                      rows="1"
                      placeholder="Titel der Publikation"
                      formControlName="title"></textarea>
                  </div>
                </div>
                <div class="flex-r gap-24">
                  <div class="input-simple flex-1-1-0">
                    <div class="input-label-wrapper">
                      <label
                        for="publicationLink{{ $index }}"
                        class="input-label">
                        Link zur Publikation {{ $index + 1
                        }}{{
                          fieldRequired(publication.get('link')) ? '*' : ''
                        }}
                      </label>
                      <div class="input-label-hint">
                        {{ getTextAreaLength(publication.get('link')) }}
                        /
                        {{ 1200 }}
                      </div>
                    </div>
                    <input
                      type="text"
                      id="publicationLink{{ $index }}"
                      name="publicationLink{{ $index }}"
                      class="input-field"
                      placeholder="Link einfügen"
                      formControlName="link" />
                  </div>
                </div>
              </div>
            }
            <p-divider type="dashed" class="divider-with-button padding-12-0">
              <button class="circle-medium" (click)="addPublication()">
                <i class="fa-solid fa-plus circle-icon"></i>
              </button>
            </p-divider>
          </ng-container>

          <ng-container formArrayName="engagements">
            @for (engagement of engagements.controls; track engagement) {
              <div class="flex-r gap-24">
                <div class="input-simple flex-1-1-0">
                  <div class="input-label-wrapper">
                    <label for="engagement{{ $index }}" class="input-label">
                      Engagement {{ $index + 1
                      }}{{ fieldRequired(engagement) ? '*' : '' }}
                    </label>
                    <div class="input-label-hint">
                      {{ getTextAreaLength(engagement) }}
                      /
                      {{ 1200 }}
                    </div>
                  </div>
                  <textarea
                    id="engagement{{ $index }}"
                    name="engagement{{ $index }}"
                    class="input-textarea"
                    rows="1"
                    placeholder="Engagement"
                    [formControlName]="$index"></textarea>
                </div>
              </div>
            }
            <p-divider type="dashed" class="divider-with-button padding-12-0">
              <button class="circle-medium" (click)="addEngagement()">
                <i class="fa-solid fa-plus circle-icon"></i>
              </button>
            </p-divider>
          </ng-container>

          <ng-container formArrayName="contributions">
            @for (contribution of contributions.controls; track contribution) {
              <div class="flex-r gap-24">
                <div class="input-simple flex-1-1-0">
                  <div class="input-label-wrapper">
                    <label for="contribution{{ $index }}" class="input-label">
                      Beitrag {{ $index + 1
                      }}{{ fieldRequired(contribution) ? '*' : '' }}
                    </label>
                    <div class="input-label-hint">
                      {{ getTextAreaLength(contribution) }}
                      /
                      {{ 1200 }}
                    </div>
                  </div>
                  <textarea
                    id="contribution{{ $index }}"
                    name="contribution{{ $index }}"
                    class="input-textarea"
                    rows="1"
                    placeholder="Beitrag"
                    [formControlName]="$index"></textarea>
                </div>
              </div>
            }
            <p-divider type="dashed" class="divider-with-button padding-12-0">
              <button class="circle-medium" (click)="addContribution()">
                <i class="fa-solid fa-plus circle-icon"></i>
              </button>
            </p-divider>
          </ng-container>
        }
        @if (userType === 'cooperation') {
          <div class="section-title padding-top-24">Sponsor Cards:</div>
          <ng-container formArrayName="sponsorCards">
            @for (sponsorCard of sponsorCards.controls; track sponsorCard) {
              <div class="flex-c gap-20" [formGroupName]="$index">
                <div class="flex-r gap-16 justify-space-between align-center">
                  <div class="font-medium-title-medium font-color-black">
                    Sponsor Card {{ $index + 1 }}:
                  </div>
                  <div class="flex-r gap-16 align-center">
                    <div class="flex-r gap-8 align-center">
                      <span class="font-regular-body-medium">Aktiv</span>
                      <p-toggleswitch formControlName="active"></p-toggleswitch>
                    </div>
                    <button
                      [disabled]="isLoading"
                      class="circle-small"
                      (click)="removeSponsorCard($index)">
                      <i class="fa-regular fa-trash-can circle-icon"></i>
                    </button>
                  </div>
                </div>
                <div class="formular-row-2-inputs">
                  <div class="flex-c flex-1-1-0 align-self-stretch gap-20">
                    <div class="input-simple flex-1-1-0">
                      <label
                        for="sponsorCardTitle{{ $index }}"
                        class="input-label">
                        Titel{{
                          fieldRequired(sponsorCard.get('title')) ? '*' : ''
                        }}
                      </label>

                      <textarea
                        id="sponsorCardTitle{{ $index }}"
                        name="sponsorCardTitle{{ $index }}"
                        class="input-textarea"
                        rows="1"
                        placeholder="Titel der Sponsor Card"
                        formControlName="title"></textarea>
                    </div>
                    <div class="input-simple flex-1-1-0">
                      <div class="input-label-wrapper">
                        <label
                          for="contribution{{ $index }}"
                          class="input-label">
                          Beschreibung{{
                            fieldRequired(sponsorCard.get('description'))
                              ? '*'
                              : ''
                          }}
                        </label>
                        <div class="input-label-hint">
                          {{
                            getTextAreaLength(sponsorCard.get('description'))
                          }}
                          /
                          {{ 250 }}
                        </div>
                      </div>
                      <textarea
                        id="sponsorCardDescription{{ $index }}"
                        name="sponsorCardDescription{{ $index }}"
                        class="input-textarea"
                        rows="2"
                        placeholder="Beschreibung"
                        formControlName="description"></textarea>
                    </div>
                    <div class="input-simple flex-1-1-0">
                      <label
                        for="sponsorCardLink{{ $index }}"
                        class="input-label">
                        Link{{
                          fieldRequired(sponsorCard.get('link')) ? '*' : ''
                        }}
                      </label>

                      <textarea
                        id="sponsorCardLink{{ $index }}"
                        name="sponsorCardLink{{ $index }}"
                        class="input-textarea"
                        rows="1"
                        placeholder="Link zum Sponsor"
                        formControlName="link"></textarea>
                    </div>
                  </div>
                  <div class="input-simple align-self-start">
                    <label
                      for="sponsorCardImage{{ $index }}"
                      class="input-label">
                      Bild{{
                        fieldRequired(sponsorCard.get('image')) ? '*' : ''
                      }}
                    </label>
                    <input
                      type="file"
                      #fileInput
                      accept="image/*"
                      (change)="onSponsorCardImageSelected($event, $index)"
                      style="display: none" />

                    <div class="flex-c gap-16">
                      @if (isLoading) {
                        <p-skeleton width="150px" height="150px"></p-skeleton>
                      } @else {
                        <div
                          class="image-upload-container"
                          [style.background-image]="
                            sponsorCard.get('selectedImage').value
                              ? 'url(' +
                                sponsorCard.get('selectedImage').value +
                                ')'
                              : ''
                          "
                          [style.background-size]="'cover'"
                          [style.background-position]="'center'"
                          [class.dashed-border-error]="
                            sponsorCard.get('image').invalid &&
                            sponsorCard.get('image').touched
                          "
                          (click)="fileInput.click()">
                          <button class="circle-medium border-none">
                            <div class="circle-icon">
                              <i class="fa-regular fa-plus"></i>
                            </div>
                          </button>
                        </div>
                      }
                      <app-error-message
                        [formField]="
                          sponsorCard.get('image')
                        "></app-error-message>
                    </div>
                  </div>
                </div>
                <div class="flex-r gap-24"></div>
                <div class="input-simple flex-1-1-0">
                  <span class="input-label"> Vorschau </span>
                  @if (isLoading) {
                    <p-skeleton width="670px" height="100px"></p-skeleton>
                  } @else {
                    <div class="sponsor-card">
                      @if (sponsorCard.get('selectedImage').value) {
                        <img
                          [src]="sponsorCard.get('selectedImage').value"
                          alt="Bild"
                          class="image" />
                      } @else {
                        <div class="image-placeholder">
                          <i class="fa-regular fa-image"></i>
                        </div>
                      }
                      <div class="text">
                        <div class="title">
                          {{ sponsorCard.get('title').value ?? 'Titel' }}
                        </div>
                        <div class="description">
                          {{
                            sponsorCard.get('description').value ??
                              'Hier steht die Beschreibung'
                          }}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            <p-divider type="dashed" class="divider-with-button padding-12-0">
              <button class="circle-medium" (click)="addSponsorCard()">
                <i class="fa-solid fa-plus circle-icon"></i>
              </button>
            </p-divider>
          </ng-container>
        }
      </form>
    } @else if (activeTab === 'bookings') {
      <app-contact-bookings [userId]="userId"></app-contact-bookings>
    } @else if (activeTab === 'appointments') {
      @if (!isLoading) {
        <app-contact-appointments [user]="user"></app-contact-appointments>
      }
    } @else if (activeTab === 'member-areas') {
      <app-contact-member-areas [userId]="userId"></app-contact-member-areas>
    } @else if (activeTab === 'notes') {
      <div class="flex-c gap-20">
        @for (note of notes; track $index) {
          <div class="note-container">
            <div class="note">
              <div
                class="avatar"
                [ngStyle]="{
                  'background-color': note.userInitials.backgroundColor,
                  color: note.userInitials.color,
                }">
                {{ note.userInitials.text }}
              </div>
              <div class="note-content">
                <div class="note-title">{{ getUserFullName(note.user) }}</div>
                <div class="note-text">{{ note.text }}</div>
                <div class="note-date">
                  {{
                    (note.updatedAt ? note.updatedAt : note.createdAt)
                      | date: 'dd.MM.yyyy HH:mm'
                  }}
                </div>
              </div>
            </div>

            <div class="note-actions">
              <p-menu
                class="note-actions-menu"
                #menu
                [model]="noteMenuItems"
                [popup]="true" />
              <button
                [disabled]="true"
                matTooltip="Diese Funktion ist noch nicht verfügbar"
                class="note-actions-trigger"
                (click)="menu.toggle($event); selectedNote = note">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </button>
            </div>
          </div>
        }
        <p-divider type="dashed" class="divider-with-button padding-12-0">
          <button
            class="circle-medium"
            (click)="addNote()"
            [disabled]="true"
            matTooltip="Diese Funktion ist noch nicht verfügbar">
            <i class="fa-solid fa-plus circle-icon"></i>
          </button>
        </p-divider>
      </div>
    }
  </div>
</div>
